"use client";

import { useEffect } from "react";

type StoreErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

const primaryCtaClass =
  "inline-flex items-center justify-center gap-2 rounded-full bg-[#ee376a] px-6 py-3 text-sm font-semibold text-white shadow-[0_16px_34px_rgba(181,95,57,0.28)] transition hover:-translate-y-0.5 hover:shadow-[0_22px_44px_rgba(181,95,57,0.34)]";

export default function StoreError({ error, reset }: StoreErrorProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6 py-16">
      <div className="max-w-lg rounded-[2rem] border border-[var(--color-line)] bg-[var(--color-surface)] p-8 text-center shadow-[var(--shadow-soft)]">
        <p className="text-sm font-semibold tracking-[0.22em] text-[var(--color-ink-muted)] uppercase">
          Store Error
        </p>
        <h2 className="mt-4 text-3xl font-semibold text-[var(--color-ink)]">
          حدثت مشكلة أثناء تحميل المتجر
        </h2>
        <p className="mt-4 text-base leading-8 text-[var(--color-ink-soft)]">
          يمكنك إعادة المحاولة الآن، أو الرجوع للصفحة الرئيسية ومتابعة التصفح.
        </p>
        <button type="button" onClick={reset} className={`${primaryCtaClass} mt-8`}>
          إعادة المحاولة
        </button>
      </div>
    </div>
  );
}
